import { Route, Routes, Navigate } from "react-router-dom";
import { useLocation } from 'react-router-dom';
import * as React from 'react';
import TestRout from "../views/user_views/forms/TestRout";
import Login from "../views/user_views/accounts/Login";
import HomePage from "../views/user_views/accounts/HomePage";
import Dashboard from "../views/user_views/drawer/ResponsiveDrawer";
import CategoryTableList from "../views/user_views/forms/AddDetails/categories/CategoryTableList";
import AddCategory from "../views/user_views/forms/AddDetails/categories/AddCategory";
import AddCoupons from "../views/user_views/forms/AddDetails/AddCoupons/AddCoupons";
import AddPOSOrder from "../views/user_views/forms/POSModule/AddPOSOrder";
import ViewOrder from "../views/user_views/forms/POSModule/ViewOrder";
import KDSView from "../views/user_views/forms/POSModule/KDSView";
import TableView from "../views/user_views/forms/AddDetails/POS/TableView";
import ViewCoupons from "../views/user_views/forms/AddDetails/AddCoupons/ViewCoupons";
import AddSize from "../views/user_views/forms/AddDetails/AddSize/AddSize";
import ViewSize from "../views/user_views/forms/AddDetails/AddSize/ViewSize";
import ViewColour from "../views/user_views/forms/AddDetails/AddColour/ViewColour";
import AddColour from "../views/user_views/forms/AddDetails/AddColour/AddColour";
import AddCustomer from "../views/user_views/forms/AddDetails/AddCustomer/AddCustomer";
import ViewCustomer from "../views/user_views/forms/AddDetails/AddCustomer/ViewCustomer";
import AddHall from "../views/user_views/forms/AddDetails/AddHall/AddHall";
import ViewHall from "../views/user_views/forms/AddDetails/AddHall/ViewHall";
import ViewResturant from "../views/user_views/forms/AddDetails/AddResturant/ViewResturant";
import AddResturant from "../views/user_views/forms/AddDetails/AddResturant/AddResturant";
import AddTable from "../views/user_views/forms/AddDetails/AddTable/AddTable";
import ViewTable from "../views/user_views/forms/AddDetails/AddTable/ViewTable";
import OpeningDay from "../views/user_views/forms/AddDetails/Day/OpeningDay";
import ClosingDay from "../views/user_views/forms/AddDetails/Day/ClosingDay";
import AccountsIntegration from "../views/user_views/forms/AddDetails/AddMasterControl/AccountsIntegration";
import ViewUser from "../views/user_views/forms/AddUser/ViewUser";
import AddUser from "../views/user_views/forms/AddUser/AddUser";
import ViewProduct from "../views/user_views/forms/AddDetails/AddProduct/ViewProduct";
import AddProduct from "../views/user_views/forms/AddDetails/AddProduct/AddProduct";
import AddRecipe from "../views/user_views/forms/AddDetails/Recipe/AddRecipe";
import ReportView from "../views/user_views/forms/AddDetails/Reports/ReportView";
import DayWiseSaleReport from "../views/user_views/forms/AddDetails/Reports/DailySaleReport";
import MonthWiseSaleReport from "../views/user_views/forms/AddDetails/Reports/MonthlySaleReport";
import DayWiseDiscountReport from "../views/user_views/forms/AddDetails/Reports/DailyDiscountReport";
import MonthlyDiscountReport from "../views/user_views/forms/AddDetails/Reports/MonthlyDiscountReport";
import DayWiseInvoiceReport from "../views/user_views/forms/AddDetails/Reports/DailyInvoiceReport";
import DayWiseOrderBilledReport from "../views/user_views/forms/AddDetails/Reports/DailyOrderBilledReport";
import DayWiseOrderCancelReport from "../views/user_views/forms/AddDetails/Reports/DailyOrderCancelReport";
import MonthlyOrderCancelReport from "../views/user_views/forms/AddDetails/Reports/MonthlyOrderCancelReport";
import DayWisePromoReport from "../views/user_views/forms/AddDetails/Reports/DailyPromoReport";
import MonthWisePromoReport from "../views/user_views/forms/AddDetails/Reports/MonthlyPromoReport";
import AddReciving from "../views/user_views/forms/AddDetails/AddReciving/AddReciving";
import RecivingList from "../views/user_views/forms/AddDetails/AddReciving/RecivingList";
import ReceivingReportWithDate from "../views/user_views/forms/AddDetails/AddReciving/ReceivingReportWithDate";
// import ReceivingTableView from "../views/user_views/forms/AddDetails/AddReciving/ReceivingTableView";
import InventoryLedger from "../views/user_views/forms/AddDetails/InventoryLedger/InventoryLedger";
import InventoryLegderDetail from "../views/user_views/forms/AddDetails/InventoryLedger/InventoryLedgerTable";
import SpecificProductSaleReport from "../views/user_views/forms/AddDetails/Reports/SpecificProductSaleReport";
import ProductSaleReport from "../views/user_views/forms/AddDetails/Reports/ProductSaleReport";
import HotSellingReport from "../views/user_views/forms/AddDetails/Reports/HotSellingReport";
import ViewRecipe from "../views/user_views/forms/AddDetails/Recipe/ViewRecipe";
import AddVendor from "../views/user_views/forms/AddDetails/Vendor/AddVendor";
import ViewVendor from "../views/user_views/forms/AddDetails/Vendor/ViewVendor";
import BackUp from "../views/user_views/forms/Settings/BackUp/BackUp";
import UserPermissions from "../views/user_views/forms/AddDetails/Permissions/UserPermissions";
import DayOpenRecord from "../views/user_views/forms/AddDetails/Reports/DayOpenRecord";
import DayOpenRecordTable from "../views/user_views/forms/AddDetails/Reports/DayOpenRecordTable";
import CreateDeal from "../views/user_views/forms/AddDetails/AddDeal/CreateDeal";
import ViewDeals from "../views/user_views/forms/AddDetails/AddDeal/ViewDeals";
import TableUpload from "../views/user_views/forms/AddDetails/AddTable/TableUpload";
import AddIssuance from "../views/user_views/forms/AddDetails/Issuance/AddIssuance";
import IssuanceDetail from "../views/user_views/forms/AddDetails/Issuance/IssuanceDetail";
import IssuanceReport from "../views/user_views/forms/AddDetails/Issuance/IssuanceReport";
import IssuanceReportByDate from "../views/user_views/forms/AddDetails/Issuance/IssuanceReportByDate";
import UploadProduct from "../views/user_views/forms/AddDetails/AddProduct/UploadProduct";
import ViewStoreProduct from "../views/user_views/forms/AddDetails/AddProduct/ViewStoreProduct";
import ViewUom from "../views/user_views/forms/AddDetails/AddUOM/ViewUom";
import DayOpenReport from "../views/user_views/forms/AddDetails/Reports/DayOpenReport";
import AddUom from "../views/user_views/forms/AddDetails/AddUOM/AddUom";
import GenerateBarcode from "../views/user_views/forms/AddDetails/Barcode/GenerateBarcode";
import WarehouseList from "../views/user_views/forms/AddDetails/Warehouse/WarehouseTableList";
import WarehouseAdd from "../views/user_views/forms/AddDetails/Warehouse/AddWarehouse";
import SubCategoryAdd from "../views/user_views/forms/AddDetails/subCategory/AddSubCategory";
import SubCategoryList from "../views/user_views/forms/AddDetails/subCategory/SubCategoryTableList";
import DemandAdd from "../views/user_views/forms/AddDetails/Demand/AddDemand";
import DemandList from "../views/user_views/forms/AddDetails/Demand/DemandList";
import AddBrand from "../views/user_views/forms/AddDetails/Brand/AddBrand";
import BrandList from "../views/user_views/forms/AddDetails/Brand/ViewBrand";
import PurchaseOrderAdd from "../views/user_views/forms/AddDetails/PurchaseOrder/AddPurchaseOrder";
import PurchaseOrderList from "../views/user_views/forms/AddDetails/PurchaseOrder/PurchaseOrderList";
import IgpAdd from "../views/user_views/forms/AddDetails/Igp/IGPAdd";
import IgpList from "../views/user_views/forms/AddDetails/Igp/IGPList";
import AddOrderCreation from "../views/user_views/forms/Production/orderCreation/AddOrderCreation";
import ListOrderCreation from "../views/user_views/forms/Production/orderCreation/ViewOrderCreation";
import ExpenseType from "../views/user_views/forms/AddDetails/expense/AddExpenseTypes";
import ExpenseTypeList from "../views/user_views/forms/AddDetails/expense/ViewExpenseType";
import AddDivision from "../views/user_views/forms/HRModule/division/addDivision";
import ViewDivision from "../views/user_views/forms/HRModule/division/viewDivision";
import AddDepartment from "../views/user_views/forms/HRModule/department/addDepartment";
import ViewDepartment from "../views/user_views/forms/HRModule/department/viewDepartment";
import AddDesignation from "../views/user_views/forms/HRModule/designation/addDesignation";
import ViewDesignation from "../views/user_views/forms/HRModule/designation/viewDesignation";
import AddShiftControl from "../views/user_views/forms/HRModule/shiftControl/addShiftControl";
import ViewShiftControl from "../views/user_views/forms/HRModule/shiftControl/viewShiftControl";
import AddEmployeeType from "../views/user_views/forms/HRModule/employeeType/addEmployeeType";
import ViewEmployeeType from "../views/user_views/forms/HRModule/employeeType/viewEmployeeType";
import AddEmployee from "../views/user_views/forms/HRModule/employee/addEmployee";
import ViewEmployee from "../views/user_views/forms/HRModule/employee/viewEmployee";
import AddSalary from "../views/user_views/forms/HRModule/salary/addSalary";
import EditSalaryWithEmpID from "../views/user_views/forms/HRModule/salary/editSalaryWithEmpID";
import EditSalary from "../views/user_views/forms/HRModule/salary/editSalary";
import AddIncrement from "../views/user_views/forms/HRModule/increment/AddIncrement";
import IncrementList from "../views/user_views/forms/HRModule/increment/incremenList";
import AddMasterControlHR from "../views/user_views/forms/HRModule/masterControlHR/AddMasterControlHR";
import STPayment from "../views/user_views/forms/HRModule/ST-Advance/STPayment";
import STReciving from "../views/user_views/forms/HRModule/ST-Advance/STReceive";
import STList from "../views/user_views/forms/HRModule/ST-Advance/STList";
import STLedger from "../views/user_views/forms/HRModule/ST-Advance/STLedger";
import STLedgerData from "../views/user_views/forms/HRModule/ST-Advance/STLedgerData";
import LTPayment from "../views/user_views/forms/HRModule/LT-Advance/LTPayment";
import LTList from "../views/user_views/forms/HRModule/LT-Advance/LTList";
import LTReciving from "../views/user_views/forms/HRModule/LT-Advance/LTReceiving";
import LTLedger from "../views/user_views/forms/HRModule/LT-Advance/LTLedger";
import LTLedgerData from "../views/user_views/forms/HRModule/LT-Advance/LTLedgerData";
import AddFineAndPenalty from "../views/user_views/forms/HRModule/fineAndPenalty/AddFineAndPenalty";
import FineAndPenaltyList from "../views/user_views/forms/HRModule/fineAndPenalty/FineAndPenaltyList";
import AttendanceUpload from "../views/user_views/forms/HRModule/attendance/attendanceUpload";
import AddProcess from "../views/user_views/forms/Production/process/AddProcess";
import ViewProcess from "../views/user_views/forms/Production/process/ViewProcess";
import AddArticle from "../views/user_views/forms/Production/article/AddArticle";
import ViewArticle from "../views/user_views/forms/Production/article/ViewArticle";
import AddProductionEmployee from "../views/user_views/forms/Production/productionEmployee/AddProductionEmployee";
import ViewProductionEmployee from "../views/user_views/forms/Production/productionEmployee/ViewProductionEmployee";
import AddArticleVariation from "../views/user_views/forms/Production/article/AddArticleVariation";
import AddMachine from "../views/user_views/forms/Production/machine/AddMachine";
import ViewMachine from "../views/user_views/forms/Production/machine/ViewMachine";
import AddArticleRecipe from "../views/user_views/forms/Production/article/AddArticleRecipe";
import MaterialRequired from "../views/user_views/forms/Production/costControl/MaterialRequired";
import ProcessCost from "../views/user_views/forms/Production/costControl/ProcessCost";
import AdminCost from "../views/user_views/forms/Production/costControl/AdminCost";
import AddProductionIssuance from "../views/user_views/forms/Production/productionIssuance/AddProductionIssuance";
import ViewProductionIssuance from "../views/user_views/forms/Production/productionIssuance/ViewProductionIssuance";
import ProductionIssuanceReport from "../views/user_views/forms/Production/productionIssuance/ProductionIssuanceReport";
import ArticleFilter from "../views/user_views/forms/Production/article/ArticleFilter";
import DetailViewArticle from "../views/user_views/forms/Production/article/DetailViewArticle";
import DetailViewArticleVariation from "../views/user_views/forms/Production/article/DetailViewArticleVariation";
import AddProductionReceiving from "../views/user_views/forms/Production/productionReceiving/AddProductionReceiving";
import ViewProductionReceiving from "../views/user_views/forms/Production/productionReceiving/ViewProductionReceiving";
import ProductionReceivingReport from "../views/user_views/forms/Production/productionReceiving/ProductionReceivingReport";
import AddCustomerCRM from "../views/user_views/forms/CRMModule/CRMCustomer/AddCustomerCRM";
import ViewCustomerCRM from "../views/user_views/forms/CRMModule/CRMCustomer/ViewCustomerCRM";
import AddProductCRM from "../views/user_views/forms/CRMModule/CRMProducts/AddProductCRM";
import ViewProductCRM from "../views/user_views/forms/CRMModule/CRMProducts/ViewProductCRM";
import UpdateCustomerCRM from "../views/user_views/forms/CRMModule/CRMCustomer/UpdateCustomerCRM";
import UploadCustomerCRM from "../views/user_views/forms/CRMModule/CRMCustomer/UploadCustomerCRM";
import AddTeamMember from "../views/user_views/forms/CRMModule/TeamMember/AddTeamMember";
import ViewTeamMember from "../views/user_views/forms/CRMModule/TeamMember/ViewTeamMember";
import AddJob from "../views/user_views/forms/CRMModule/Job/AddJob";
import ViewJob from "../views/user_views/forms/CRMModule/Job/ViewJob";
import AddDocumentType from "../views/user_views/forms/CRMModule/Job/AddDocumentType";
import UploadDocument from "../views/user_views/forms/CRMModule/Job/UploadDocument";
import AddLevelTwo from "../views/user_views/forms/AccountsModule/LevelTwo/AddLevelTwo";
import ViewLevelTwo from "../views/user_views/forms/AccountsModule/LevelTwo/ViewLevelTwo";
import ViewLevelOne from "../views/user_views/forms/AccountsModule/LevelOne/ViewLevelOne";
import AddLevelThree from "../views/user_views/forms/AccountsModule/LevelThree/AddLevelThree";
import ViewLevelThree from "../views/user_views/forms/AccountsModule/LevelThree/ViewLevelThree";
import AddLevelFour from "../views/user_views/forms/AccountsModule/LevelFour/AddLevelFour";
import ViewLevelFour from "../views/user_views/forms/AccountsModule/LevelFour/ViewLevelFour";
import UploadLevelThree from "../views/user_views/forms/AccountsModule/LevelThree/UploadLevelThree";
import UploadLevelFour from "../views/user_views/forms/AccountsModule/LevelFour/UploadLevelFour";
import CashPaymentVoucher from "../views/user_views/forms/AccountsModule/Vouchers/CashPaymentVoucher";
import CashReceiptVoucher from "../views/user_views/forms/AccountsModule/Vouchers/CashReceiptVoucher";
import BankPaymentVoucher from "../views/user_views/forms/AccountsModule/Vouchers/BankPaymentVoucher";
import BankReceiptVoucher from "../views/user_views/forms/AccountsModule/Vouchers/BankReceiptVoucher";
import JournalVoucher2 from "../views/user_views/forms/AccountsModule/Vouchers/JournalVoucher";
import VoucherVerification from "../views/user_views/forms/AccountsModule/Vouchers/VoucherVerification";
import VoucherSearch2 from "../views/user_views/forms/AccountsModule/Vouchers/VoucherSearch";
import VoucherSearchDetails2 from "../views/user_views/forms/AccountsModule/Vouchers/VoucherSearchDetails";
import LedgerSearch from "../views/user_views/forms/AccountsModule/Ledger/LedgerSearch";
import LedgerSearchDetails from "../views/user_views/forms/AccountsModule/Ledger/LedgerSearchDetails";
import ViewTrail from "../views/user_views/forms/AccountsModule/TrailBalance/ViewTrail";
import TrailSearch from "../views/user_views/forms/AccountsModule/TrailBalance/TrailSearch";
import ViewChartOfAccount from "../views/user_views/forms/AccountsModule/ChartOfAccount/ViewChartOfAccount";
import ViewAging from "../views/user_views/forms/AccountsModule/Aging/ViewAging";
import ViewCashBook from "../views/user_views/forms/AccountsModule/CashBook/ViewCashBook";
import AddInvoice from "../views/user_views/forms/AccountsModule/Invoice/AddInvoice";
import ViewInvoice from "../views/user_views/forms/AccountsModule/Invoice/ViewInvoice";
import LoginHistory from "../views/user_views/forms/Settings/loginHistory/loginHistory";
import AccountsDashboard from "../views/user_views/forms/AccountsModule/AccountsDashboard/AccountsDashboard";
import DetailJobView from "../views/user_views/forms/CRMModule/Job/DetailJobView";
import JobReports from "../views/user_views/forms/CRMModule/Job/JobReports";
import AttendanceView from "../views/user_views/forms/HRModule/attendance/attendanceView";
import GenerateSalary from "../views/user_views/forms/HRModule/genrateSalary/GenrateSalary";
import AddArea from "../views/user_views/forms/AddDetails/AddArea/addArea";
import ViewArea from "../views/user_views/forms/AddDetails/AddArea/viewArea";
import AddShop from "../views/user_views/forms/AddDetails/AddShop/AddShop";
import ViewShop from "../views/user_views/forms/AddDetails/AddShop/ViewShop";
import AddOrderBooking from "../views/user_views/forms/AddDetails/OrderBooking/AddOrderBooking";
import ViewOrderBooking from "../views/user_views/forms/AddDetails/OrderBooking/ViewOrderBooking";
import OrderBookingReports from "../views/user_views/forms/AddDetails/OrderBooking/OrderBookingReports";
import AddPaymentReceving from "../views/user_views/forms/AddDetails/PaymentReceiving/AddPaymentReceving";
import ViewPaymentReceiving from "../views/user_views/forms/AddDetails/PaymentReceiving/ViewPaymentReceiving";
import WhatsApp from "../views/user_views/forms/Settings/WhatsAppSMS.js/WhatsApp";
import ReturnReceving from "../views/user_views/forms/AddDetails/AddReciving/ReturnReceving";
import ReturnRecevingList from "../views/user_views/forms/AddDetails/AddReciving/ReturnRecevingList";
import AddConstructionOrder from "../views/user_views/forms/ConstructionModule/ConstructionOrder/AddConstructionOrder";
import ViewConstructionOrder from "../views/user_views/forms/ConstructionModule/ConstructionOrder/ViewConstructionOrder";
import AddExpense from "../views/user_views/forms/ConstructionModule/Expense/AddExpense";
import ConstructionDetailView from "../views/user_views/forms/ConstructionModule/ConstructionOrder/ConstructionDetailView";
import ConstructionOrderDashboard from "../views/user_views/forms/ConstructionModule/ConstructionOrder/ConstructionOrderDashboard";
import ViewHSCode from "../views/user_views/forms/FBRInvoice/HSCode/ViewHSCode";
import CompanyDetails from "../views/user_views/forms/AddDetails/AddResturant/CompanyDetails";
import PageNotFound from "../views/user_views/accounts/PageNotFound";
import FBRAddCompany from "../views/user_views/forms/FBRInvoice/FBRCompany/FBRAddCompany";
import FBRViewCompany from "../views/user_views/forms/FBRInvoice/FBRCompany/FBRViewCompany";
import FBRAddProduct from "../views/user_views/forms/FBRInvoice/FBRProduct/FBRAddProduct";
import FBRViewProduct from "../views/user_views/forms/FBRInvoice/FBRProduct/FBRViewProduct";
import FBRAddBuyer from "../views/user_views/forms/FBRInvoice/FBRBuyer/FBRAddBuyer";
import FBRViewBuyer from "../views/user_views/forms/FBRInvoice/FBRBuyer/FBRViewBuyer";
import ViewScenario from "../views/user_views/forms/FBRInvoice/Scenario/ViewScenario";
import PaymentReports from "../views/user_views/forms/AddDetails/PaymentReceiving/PaymentReports";
import BadDebtsReport from "../views/user_views/forms/AddDetails/Reports/BadDebtsReport";
import AreaRecoveryReport from "../views/user_views/forms/AddDetails/Reports/AreaRecoveryReport";
import EditOrderBooking from "../views/user_views/forms/AddDetails/OrderBooking/EditOrderBooking";
import PurchaseProductReport from "../views/user_views/forms/AddDetails/Reports/PurchaseProductReport";
import SKUReport from "../views/user_views/forms/AddDetails/Reports/SKUReport";
import ViewProfitLoss from "../views/user_views/forms/AccountsModule/ProfitAndLoss/ViewProfitLoss";


export default function Routing() {
  const token = localStorage.getItem("token");
  const location = useLocation();

  React.useEffect(() => {

  }, [location]);

  return (
    <Routes>
      <Route path="/" element={token ? <Navigate to="/home" replace /> : <Navigate to="/login" replace />} />
      <Route path="/login" element={<Login />}></Route>
      <Route path="/home" element={<HomePage />}></Route>
      <Route path="/test" element={<TestRout />}></Route>
      <Route path="/pos-order" element={<AddPOSOrder />}></Route>
      <Route path="/view-order" element={<ViewOrder />}></Route>
      <Route path="/report" element={<ReportView />}></Route>
      <Route path="/table" element={<TableView />}></Route>
      <Route path="/kds" element={<KDSView />} />
      <Route path="/daliy/sale-report" element={< DayWiseSaleReport />} />
      <Route path="/daliy/dayOpen-sale-report" element={< DayOpenReport />} />
      <Route path="/Report/Specific-Product-Sale-report" element={<SpecificProductSaleReport />} />
      <Route path="/Report/Product-Sale-report" element={<ProductSaleReport />} />
      <Route path="/Report/hot-selling-report" element={<HotSellingReport />} />
      <Route path="/monthly/sale-report" element={< MonthWiseSaleReport />} />
      <Route path="/daliy/discount-report" element={<DayWiseDiscountReport />} />
      <Route path="/monthly/discount-report" element={<MonthlyDiscountReport />} />
      <Route path="/daliy/invoice-report" element={<DayWiseInvoiceReport />} />
      <Route path="/daliy/order-billed-report" element={<DayWiseOrderBilledReport />} />
      <Route path="/daliy/orderCancel-report" element={<DayWiseOrderCancelReport />} />
      <Route path="/monthly/orderCancel-report" element={<MonthlyOrderCancelReport />} />
      <Route path="/daliy/promo-report" element={<DayWisePromoReport />} />
      <Route path="/monthly/promo-report" element={<MonthWisePromoReport />} />
      <Route path="/bad-debts-report" element={<BadDebtsReport />} />
      <Route path="/area-recovery-report" element={<AreaRecoveryReport />} />
      <Route path="/purchase-product-report" element={<PurchaseProductReport />} />
      <Route path="/sku-report" element={<SKUReport />} />
      <Route path="/company/:id" element={<CompanyDetails />} />
      <Route path="/404/page-not-found" element={<PageNotFound />} />
      <Route path="*" element={<Navigate to="/404/page-not-found" replace />} />


      {/* INVENTORY ROUTES */}
      {true && (
        <Route path="/inventory" element={<Dashboard />}>
          <Route path="/inventory/issuance/addIssuance" element={<AddIssuance />} />
          <Route path="/inventory/issuance/IssuanceDetail" element={<IssuanceDetail />} />
          <Route path="/inventory/issuance/IssuanceById" element={<IssuanceReport />} />
          <Route path="/inventory/issuance/IssuanceWithDate" element={<IssuanceReportByDate />} />
          <Route path="/inventory/Vendor/addVendor" element={<AddVendor />} />
          <Route path="/inventory/uomlist" element={<ViewUom />} />
          <Route path="/inventory/permission" element={<UserPermissions />} />
          <Route path="/inventory/Vendor/listVendor" element={<ViewVendor />} />
          <Route path="/inventory/deal/addDeal" element={<CreateDeal />} />
          <Route path="/inventory/deal/dealList" element={<ViewDeals />} />
          <Route path="/inventory/Coupon/AddCoupon" element={<AddCoupons />} />
          <Route path="/inventory/Coupon/listCoupon" element={<ViewCoupons />} />
          <Route path="/inventory/Size/addSize" element={<AddSize />} />
          <Route path="/inventory/Size/listsize" element={<ViewSize />} />
          <Route path="/inventory/barcode/generateBarcode" element={<GenerateBarcode />} />
          <Route path="/inventory/Colour/addColour" element={<AddColour />} />
          <Route path="/inventory/Colour/listColour" element={<ViewColour />} />
          <Route path="/inventory/uom/adduom" element={<AddUom />} />
          <Route path="/inventory/uom/listuom" element={<ViewUom />} />
          <Route path="/inventory/Customer/addCustomer" element={<AddCustomer />} />
          <Route path="/inventory/Customer/listCustomer" element={<ViewCustomer />} />
          <Route path="/inventory/Hall/addHall" element={<AddHall />} />
          <Route path="/inventory/Hall/listHall" element={<ViewHall />} />
          <Route path="/inventory/Restaurant/addRestaurant" element={<AddResturant />} />
          <Route path="/inventory/Restaurant/listRestaurant" element={<ViewResturant />} />
          <Route path="/inventory/Table/addTable" element={<AddTable />} />
          <Route path="/inventory/Table/uploadTable" element={<TableUpload />} />
          <Route path="/inventory/Table/listTable" element={<ViewTable />} />
          <Route path="/inventory/User/addUser" element={<AddUser />} />
          <Route path="/inventory/User/listUser" element={<ViewUser />} />
          <Route path="/inventory/Product/addProduct" element={<AddProduct />} />
          <Route path="/inventory/product/uploadProduct" element={<UploadProduct />} />
          <Route path="/inventory/Product/listProduct" element={<ViewProduct />} />
          <Route path="/inventory/Product/storeProductList" element={<ViewStoreProduct />} />
          <Route path="/inventory/receiving/new" element={<AddReciving />} />
          <Route path="/inventory/receiving/list" element={<RecivingList />} />
          <Route path="/inventory/receiving/report" element={<ReceivingReportWithDate />} />
          <Route path="/inventory/receiving/return/new" element={<ReturnReceving />} />
          <Route path="/inventory/receiving/return/list" element={<ReturnRecevingList />} />
          {/* <Route path="/inventory/Product/RecivingReportDate/TableView" element={<ReceivingTableView />} /> */}
          <Route path="/inventory/Recipe/addRecipe" element={<AddRecipe />} />
          <Route path="/inventory/Recipe/listRecipe" element={<ViewRecipe />} />
          <Route path="/inventory/ledger" element={<InventoryLedger />} />
          <Route path="/inventory/Ledger-List" element={<InventoryLegderDetail />} />
          <Route path="/inventory/catagory/addcatagory" element={<AddCategory />} />
          <Route path="/inventory/catagory/listcatagory" element={<CategoryTableList />} />
          <Route path="/inventory/warehouse/warehousAdd" element={<WarehouseAdd />} />
          <Route path="/inventory/warehouse/warehouseList" element={<WarehouseList />} />
          <Route path="/inventory/subCategory/subCategoryAdd" element={<SubCategoryAdd />} />
          <Route path="/inventory/subCategory/subCategoryList" element={<SubCategoryList />} />
          <Route path="/inventory/demand/DemandAdd" element={<DemandAdd />} />
          <Route path="/inventory/demand/DemandList" element={<DemandList />} />
          <Route path="/inventory/brand/addBrand" element={<AddBrand />} />
          <Route path="/inventory/brand/brandList" element={<BrandList />} />
          <Route path="/inventory/purchase/PurchaseOrderAdd" element={<PurchaseOrderAdd />} />
          <Route path="/inventory/purchase/PurchaseOrderList" element={<PurchaseOrderList />} />
          <Route path="/inventory/igp/IgpAdd" element={<IgpAdd />} />
          <Route path="/inventory/igp/IgpList" element={<IgpList />} />
          <Route path="/inventory/expense/expenseType" element={<ExpenseType />} />
          <Route path="/inventory/expense/expenseTypeList" element={<ExpenseTypeList />} />
          <Route path="/inventory/shop/new" element={<AddShop />} />
          <Route path="/inventory/shops" element={<ViewShop />} />
          <Route path="/inventory/Area/addArea" element={<AddArea />} />
          <Route path="/inventory/Area/listArea" element={<ViewArea />} />
          <Route path="/inventory/order-bookings/new" element={<AddOrderBooking />} />
          <Route path="/inventory/order-bookings/list" element={<ViewOrderBooking />} />
          <Route path="/inventory/order-bookings/reports" element={<OrderBookingReports />} />
          <Route path="/inventory/order-bookings/edit" element={<EditOrderBooking />} />
          <Route path="/inventory/payment-recevings/new" element={<AddPaymentReceving />} />
          <Route path="/inventory/payment-recevings/list" element={<ViewPaymentReceiving />} />
          <Route path="/inventory/payment-report" element={<PaymentReports />} />



        </Route>
      )}


      {/* SETTING ROUTES */}
      {true && (
        <Route path="/setting" element={<Dashboard />}>
          <Route path="/setting/opening" element={<OpeningDay />} />
          <Route path="/setting/closing" element={<ClosingDay />} />
          <Route path="/setting/addUser" element={<AddUser />} />
          <Route path="/setting/listUser" element={<ViewUser />} />
          <Route path="/setting/permission" element={<UserPermissions />} />
          <Route path="/setting/dayOpen_record" element={<DayOpenRecord />} />
          <Route path="/setting/dayOpen_record_table" element={<DayOpenRecordTable />} />
          <Route path="/setting/accounts-integration" element={<AccountsIntegration />} />
          <Route path="/setting/Company/addCompany" element={<AddResturant />} />
          <Route path="/setting/Company/listCompany" element={<ViewResturant />} />
          <Route path="/setting/BackUp" element={<BackUp />} />
          <Route path="/setting/loginHistory" element={<LoginHistory />} />
          <Route path="/setting/whatsapp" element={<WhatsApp />}></Route>
        </Route>
      )}


      {/* PRODUCTION ROUTES */}
      {true && (
        <Route path="/production" element={<Dashboard />}>
          <Route path="/production/process/AddProcess" element={<AddProcess />} />
          <Route path="/production/process/ViewProcess" element={<ViewProcess />} />
          <Route path="/production/OrderCreation/AddOrderCreation" element={<AddOrderCreation />} />
          <Route path="/production/OrderCreation/ListOrderCreation" element={<ListOrderCreation />} />
          <Route path="/production/Article/AddArticle" element={<AddArticle />} />
          <Route path="/production/Article/AddArticleVariation" element={<AddArticleVariation />} />
          <Route path="/production/Article/AddArticleRecipe" element={<AddArticleRecipe />} />
          <Route path="/production/Article/ViewArticle" element={<ViewArticle />} />
          <Route path="/production/Article/DetailViewArticle" element={<DetailViewArticle />} />
          <Route path="/production/Article/DetailViewArticleVariation" element={<DetailViewArticleVariation />} />
          <Route path="/production/Article/ArticleFilter" element={<ArticleFilter />} />
          <Route path="/production/Employee/AddProductionEmployee" element={<AddProductionEmployee />} />
          <Route path="/production/Employee/ViewProductionEmployee" element={<ViewProductionEmployee />} />
          <Route path="/production/Machine/AddMachine" element={<AddMachine />} />
          <Route path="/production/Machine/ViewMachine" element={<ViewMachine />} />
          <Route path="/production/CostControl/MaterialRequired" element={<MaterialRequired />} />
          <Route path="/production/CostControl/ProcessRequired" element={<ProcessCost />} />
          <Route path="/production/CostControl/AdminCostRequired" element={<AdminCost />} />
          <Route path="/production/ProductionIssuance/AddProductionIssuance" element={<AddProductionIssuance />} />
          <Route path="/production/ProductionIssuance/ViewProductionIssuance" element={<ViewProductionIssuance />} />
          <Route path="/production/ProductionIssuance/ProductionIssuanceReport" element={<ProductionIssuanceReport />} />
          <Route path="/production/ProductionReceiving/AddProductionReceiving" element={<AddProductionReceiving />} />
          <Route path="/production/ProductionReceiving/ViewProductionReceiving" element={<ViewProductionReceiving />} />
          <Route path="/production/ProductionReceiving/ProductionReceivingReport" element={<ProductionReceivingReport />} />
        </Route>
      )}


      {/* HR ROUTES */}
      {true && (
        <Route path="/hr" element={<Dashboard />}>
          <Route path="/hr/division/AddDivision" element={<AddDivision />} />
          <Route path="/hr/division/ViewDivision" element={<ViewDivision />} />
          <Route path="/hr/department/AddDepartment" element={<AddDepartment />} />
          <Route path="/hr/department/ViewDepartment" element={<ViewDepartment />} />
          <Route path="/hr/designation/AddDesignation" element={<AddDesignation />} />
          <Route path="/hr/designation/ViewDesignation" element={<ViewDesignation />} />
          <Route path="/hr/shiftControl/AddShiftControl" element={<AddShiftControl />} />
          <Route path="/hr/shiftControl/ViewShiftControl" element={<ViewShiftControl />} />
          <Route path="/hr/employeeType/AddEmployeeType" element={<AddEmployeeType />} />
          <Route path="/hr/employeeType/ViewEmployeeType" element={<ViewEmployeeType />} />
          <Route path="/hr/employee/AddEmployee" element={<AddEmployee />} />
          <Route path="/hr/employee/ViewEmployee" element={<ViewEmployee />} />
          <Route path="/hr/salary/AddSalary" element={<AddSalary />} />
          <Route path="/hr/salary/EditSalaryWithEmpID" element={<EditSalaryWithEmpID />} />
          <Route path="/hr/salary/EditSalary" element={<EditSalary />} />
          <Route path="/hr/increment/AddIncrement" element={<AddIncrement />} />
          <Route path="/hr/increment/IncrementList" element={<IncrementList />} />
          <Route path="/hr/masterControl/AddMasterControlHR" element={<AddMasterControlHR />} />
          <Route path="/hr/shortTerm/STPayment" element={<STPayment />} />
          <Route path="/hr/shortTerm/STReciving" element={<STReciving />} />
          <Route path="/hr/shortTerm/STList" element={<STList />} />
          <Route path="/hr/shortTerm/STLedger" element={<STLedger />} />
          <Route path="/hr/shortTerm/STLedgerData" element={<STLedgerData />} />
          <Route path="/hr/longTerm/LTPayment" element={<LTPayment />} />
          <Route path="/hr/longTerm/LTReciving" element={<LTReciving />} />
          <Route path="/hr/longTerm/LTList" element={<LTList />} />
          <Route path="/hr/longTerm/LTLedger" element={<LTLedger />} />
          <Route path="/hr/longTerm/LTLedgerData" element={<LTLedgerData />} />
          <Route path="/hr/fine/AddFineAndPenalty" element={<AddFineAndPenalty />} />
          <Route path="/hr/fine/FineAndPenaltyList" element={<FineAndPenaltyList />} />
          <Route path="/hr/attendance/AttendanceUpload" element={<AttendanceUpload />} />
          <Route path="/hr/attendance/AttendanceView" element={<AttendanceView />} />
          <Route path="/hr/salary/GenerateSalary" element={<GenerateSalary />} />


        </Route>
      )}


      {/* CRM ROUTES */}
      {true && (
        <Route path="/crm" element={<Dashboard />}>
          <Route path="/crm/customer/AddCustomer" element={<AddCustomerCRM />} />
          <Route path="/crm/customer/ViewCustomer" element={<ViewCustomerCRM />} />
          <Route path="/crm/customer/UpdateCustomer" element={<UpdateCustomerCRM />} />
          <Route path="/crm/customer/UploadCustomer" element={<UploadCustomerCRM />} />
          <Route path="/crm/product/AddProduct" element={<AddProductCRM />} />
          <Route path="/crm/product/ViewProduct" element={<ViewProductCRM />} />
          <Route path="/crm/teamMember/AddTeamMember" element={<AddTeamMember />} />
          <Route path="/crm/teamMember/ViewTeamMember" element={<ViewTeamMember />} />
          <Route path="/crm/job/AddJob" element={<AddJob />} />
          <Route path="/crm/job/ViewJob" element={<ViewJob />} />
          <Route path="/crm/job/DocumentType" element={<AddDocumentType />} />
          <Route path="/crm/job/UploadDocument/:jobId" element={<UploadDocument />} />
          <Route path="/crm/job/DetailJobView" element={<DetailJobView />} />
          <Route path="/crm/job/JobReport" element={<JobReports />} />

        </Route>
      )}

      {/* CONSTRUCTION ROUTES */}
      {true && (
        <Route path="/contruction" element={<Dashboard />}>
          <Route index element={<ConstructionOrderDashboard />} />
          <Route path="/contruction/catagory/new" element={<AddCategory />} />
          <Route path="/contruction/catagory/list" element={<CategoryTableList />} />
          <Route path="/contruction/order/dashboard" element={<ConstructionOrderDashboard />} />
          <Route path="/contruction/order/new" element={<AddConstructionOrder />} />
          <Route path="/contruction/order/list" element={<ViewConstructionOrder />} />
          <Route path="/contruction/order/details" element={<ConstructionDetailView />} />
          <Route path="/contruction/expense/new" element={<AddExpense />} />


        </Route>
      )}


      {/* FBR INVOICE ROUTES */}
      {true && (
        <Route path="/fbr" element={<Dashboard />}>
          <Route path="/fbr/company/new" element={<FBRAddCompany />} />
          <Route path="/fbr/company/list" element={<FBRViewCompany />} />
          <Route path="/fbr/hscode/list" element={<ViewHSCode />} />
          <Route path="/fbr/product/new" element={<FBRAddProduct />} />
          <Route path="/fbr/product/list" element={<FBRViewProduct />} />
          <Route path="/fbr/buyer/new" element={<FBRAddBuyer />} />
          <Route path="/fbr/buyer/list" element={<FBRViewBuyer />} />
          <Route path="/fbr/scenario/list" element={<ViewScenario />} />


        </Route>
      )}


      {/* STORE ROUTES */}
      {true && (
        <Route path="/store" element={<Dashboard />}>

        </Route>
      )}


      {/* ACCOUNTS MODULE ROUTES */}
      {true && (
        <Route path="/accountsModule" element={<Dashboard />}>
          <Route index element={<AccountsDashboard />} />
          <Route path="/accountsModule/AccountsDashboard" element={<AccountsDashboard />} />
          <Route path="/accountsModule/Invoice/AddInvoice" element={<AddInvoice />} />
          <Route path="/accountsModule/Invoice/ViewInvoice" element={<ViewInvoice />} />
          <Route path="/accountsModule/levelOne/ViewLevelOne" element={<ViewLevelOne />} />
          <Route path="/accountsModule/levelTwo/AddLevelTwo" element={<AddLevelTwo />} />
          <Route path="/accountsModule/levelTwo/ViewLevelTwo" element={<ViewLevelTwo />} />
          <Route path="/accountsModule/levelThree/AddLevelThree" element={<AddLevelThree />} />
          <Route path="/accountsModule/levelThree/ViewLevelThree" element={<ViewLevelThree />} />
          <Route path="/accountsModule/levelThree/UploadLevelThree" element={<UploadLevelThree />} />
          <Route path="/accountsModule/levelFour/AddLevelFour" element={<AddLevelFour />} />
          <Route path="/accountsModule/levelFour/ViewLevelFour" element={<ViewLevelFour />} />
          <Route path="/accountsModule/levelFour/UploadLevelFour" element={<UploadLevelFour />} />
          <Route path="/accountsModule/Voucher/CashPaymentVoucher" element={<CashPaymentVoucher />} />
          <Route path="/accountsModule/Voucher/CashReceiptVoucher" element={<CashReceiptVoucher />} />
          <Route path="/accountsModule/Voucher/BankPaymentVoucher" element={<BankPaymentVoucher />} />
          <Route path="/accountsModule/Voucher/BankReceiptVoucher" element={<BankReceiptVoucher />} />
          <Route path="/accountsModule/Voucher/JournalVoucher" element={<JournalVoucher2 />} />
          <Route path="/accountsModule/Voucher/VoucherVerification" element={<VoucherVerification />} />
          <Route path="/accountsModule/Voucher/VoucherSearch" element={<VoucherSearch2 />} />
          <Route path="/accountsModule/Voucher/VoucherSearchDetails" element={<VoucherSearchDetails2 />} />
          <Route path="/accountsModule/Ledger" element={<LedgerSearch />} />
          <Route path="/accountsModule/LedgerDetails" element={<LedgerSearchDetails />} />
          <Route path="/accountsModule/TrailBalance" element={<ViewTrail />} />
          <Route path="/accountsModule/TrailBalance/TrailSearch" element={<TrailSearch />} />
          <Route path="/accountsModule/ViewChartOfAccount" element={<ViewChartOfAccount />} />
          <Route path="/accountsModule/ViewAging" element={<ViewAging />} />
          <Route path="/accountsModule/ViewCashBook" element={<ViewCashBook />} />
          <Route path="/accountsModule/ProfitLoss" element={<ViewProfitLoss />} />
          
        </Route>
      )}


    </Routes>
  )
}